import { useCallback, useEffect, useState, useMemo } from "react";
import { getData } from "../helpers/api";
import { Col, Row, Card, Skeleton, Alert, Typography } from "antd";
import ConfirmationCard from "../components/statitistics/confirmationCard";
import StatisticsFilter from "../components/statitistics/Filter";

const { Title } = Typography;

const Statistics = () => {
    const [filter, setFilter] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [stats, setStats] = useState({
        delivery: { totalOrders: 0, statistics: [] },
        confirmation: { totalOrders: 0, statistics: [] },
        spend: { spend: 0, 'spend/delivered': 0, 'spend/confirmed': 0 },
        sheetConfirmation: { totalOrders: 0, statistics: [], commandesFeuilles: 0 }
    });

    const fetchStatistics = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const [deliveryData, confirmationData, spendData, sheetOrderStatistics] = await Promise.all([
                getData("/statistics/delivery-status-stats", filter),
                getData("/statistics/confirmation-status-stats", filter),
                getData("/statistics/spend", filter),
                getData("/statistics/confirmation-sheet-statistics", filter)
            ]);

            setStats({
                delivery: deliveryData.data,
                confirmation: confirmationData.data,
                spend: spendData.data,
                sheetConfirmation: sheetOrderStatistics.data
            });
        } catch (error) {
            setError(error.message || "Échec de la récupération des statistiques");
        } finally {
            setLoading(false);
        }
    }, [filter]);

    useEffect(() => {
        fetchStatistics();
    }, [fetchStatistics]);

    const totalOrders = useMemo(() => stats.delivery.totalOrders || stats.confirmation.totalOrders || 0, [stats]);

    if (loading) {
        return (
            <div style={{ padding: "20px" }}>
                <Skeleton active />
            </div>
        );
    }

    if (error) {
        return (
            <Alert
                message="Erreur"
                description={error}
                type="error"
                showIcon
                style={{ margin: "20px" }}
            />
        );
    }
    return (
        <div style={{ padding: "20px" }}>
            <Title level={4} style={{ marginBottom: "20px" }}>Total des commandes: {totalOrders}</Title>

            <StatisticsFilter setFilter={setFilter} filter={filter} />

            <div style={{ marginTop: "24px" }}>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Card title="Statut de confirmation" bordered={false}>
                            <Row gutter={[16, 16]}>
                                {stats.confirmation.statistics.map((stat, index) => (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                                        <ConfirmationCard statistic={stat} />
                                    </Col>
                                ))}
                            </Row>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Statut de confirmation Commandes de feuilles" bordered={false}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <ConfirmationCard statistic={{
                                        label: "Total",
                                        count: stats.sheetConfirmation.totalOrders || 0,
                                        percent: '100 %'
                                    }} />
                                </Col>
                                {stats.sheetConfirmation.statistics?.map((stat, index) => (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                                        <ConfirmationCard statistic={stat} />
                                    </Col>
                                ))}
                            </Row>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Statut de livraison" bordered={false}>
                            <Row gutter={[16, 16]}>
                                {stats.delivery.statistics.map((stat, index) => (
                                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                                        <ConfirmationCard statistic={stat} />
                                    </Col>
                                ))}
                            </Row>
                        </Card>
                    </Col>

                    <Col span={24}>
                        <Card title="Statistiques des dépenses" bordered={false}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={24} md={8}>
                                    <Card type="inner" title="Dépenses totales">
                                        <Title level={3}>{stats.spend.spend.toFixed(2)} DH</Title>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                    <Card type="inner" title="Dépenses par commande livrée">
                                        <Title level={3}>{stats.spend['spend/delivered'].toFixed(2)} DH</Title>
                                    </Card>
                                </Col>
                                <Col xs={24} sm={24} md={8}>
                                    <Card type="inner" title="Dépenses par commande confirmée">
                                        <Title level={3}>{stats.spend['spend/confirmed'].toFixed(2)} DH</Title>
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Statistics;